import { render, staticRenderFns } from "./UpdatePackageAssociationCheckbox.vue?vue&type=template&id=7b9d3774&"
import script from "./UpdatePackageAssociationCheckbox.vue?vue&type=script&lang=ts&"
export * from "./UpdatePackageAssociationCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VSimpleCheckbox})
